var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.editor
    ? _c(
        "div",
        {
          staticClass: "container",
          class: { "is-fullscreen": _vm.isFullscreen },
        },
        [
          _c("div", { staticClass: "control-group" }, [
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Hoàn tác (Undo)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button_control",
                        on: {
                          click: function ($event) {
                            _vm.editor.chain().focus().undo().run()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-refresh-left",
                          staticStyle: {
                            "font-size": "16px",
                            color: "#475569",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Làm lại (Redo)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button_control",
                        on: {
                          click: function ($event) {
                            _vm.editor.chain().focus().redo().run()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-refresh-right",
                          staticStyle: {
                            "font-size": "16px",
                            color: "#475569",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Chọn kiểu tiêu đề",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button_control-select",
                        staticStyle: { width: "105px" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { size: "mini" },
                            on: { change: _vm.updateHeading },
                            model: {
                              value: _vm.controlHeading.selectedHeading,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.controlHeading,
                                  "selectedHeading",
                                  $$v
                                )
                              },
                              expression: "controlHeading.selectedHeading",
                            },
                          },
                          [
                            _vm._l(
                              _vm.controlHeading.countOption,
                              function (item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: {
                                    value: item + 2,
                                    label: "Heading " + item,
                                  },
                                })
                              }
                            ),
                            _c("el-option", {
                              attrs: { value: null, label: "Mặc định" },
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Chọn phông chữ",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button_control-select",
                        staticStyle: { width: "110px" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { size: "mini" },
                            model: {
                              value: _vm.controlFontFamily.selectedFontFamily,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.controlFontFamily,
                                  "selectedFontFamily",
                                  $$v
                                )
                              },
                              expression:
                                "controlFontFamily.selectedFontFamily",
                            },
                          },
                          _vm._l(
                            _vm.controlFontFamily.optionsFontFamily,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { value: item.value, label: item.label },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Chọn cỡ chữ",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button_control-select",
                        staticStyle: { width: "85px" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { size: "mini", placeholder: "Cỡ chữ" },
                            on: { change: _vm.updateFontSize },
                            model: {
                              value: _vm.selectedFontSize,
                              callback: function ($$v) {
                                _vm.selectedFontSize = $$v
                              },
                              expression: "selectedFontSize",
                            },
                          },
                          _vm._l(_vm.fontSizes, function (size) {
                            return _c("el-option", {
                              key: size,
                              attrs: { value: size, label: size },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Khoảng cách dòng",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button_control-select",
                        staticStyle: { width: "80px" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { size: "mini", placeholder: "Dòng" },
                            on: { change: _vm.updateLineHeight },
                            model: {
                              value: _vm.selectedLineHeight,
                              callback: function ($$v) {
                                _vm.selectedLineHeight = $$v
                              },
                              expression: "selectedLineHeight",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { value: "normal", label: "Mặc định" },
                            }),
                            _c("el-option", {
                              attrs: { value: "1.15", label: "1.15" },
                            }),
                            _c("el-option", {
                              attrs: { value: "1.3", label: "1.3" },
                            }),
                            _c("el-option", {
                              attrs: { value: "1.5", label: "1.5" },
                            }),
                            _c("el-option", {
                              attrs: { value: "1.8", label: "1.8" },
                            }),
                            _c("el-option", {
                              attrs: { value: "2.0", label: "2.0" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "In đậm",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.editor.isActive("bold"),
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor.chain().focus().toggleBold().run()
                          },
                        },
                      },
                      [_c("el-image", { attrs: { src: _vm.icon.bold } })],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "In nghiêng",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.editor.isActive("italic"),
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.editor.chain().focus().toggleItalic().run()
                          },
                        },
                      },
                      [_c("el-image", { attrs: { src: _vm.icon.italic } })],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Gạch chân",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.editor.isActive("underline"),
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor.chain().focus().toggleUnderline().run()
                          },
                        },
                      },
                      [_c("el-image", { attrs: { src: _vm.icon.underline } })],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Gạch ngang chữ",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.editor.isActive("strike"),
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.editor.chain().focus().toggleStrike().run()
                          },
                        },
                      },
                      [
                        _c("el-image", {
                          attrs: { src: _vm.icon.strikethrough },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Xóa toàn bộ định dạng",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button_control",
                        on: {
                          click: function ($event) {
                            _vm.editor
                              .chain()
                              .focus()
                              .clearNodes()
                              .unsetAllMarks()
                              .run()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-magic-stick",
                          staticStyle: {
                            "font-size": "16px",
                            color: "#475569",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Màu chữ",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "el-popover",
                      {
                        staticClass: "button_control",
                        attrs: { placement: "bottom", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "reference",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "button_control style_text",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                            "line-height": "normal",
                                          },
                                        },
                                        [
                                          _c("el-image", {
                                            attrs: { src: _vm.icon.text_a },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("div", {
                                        style: {
                                          height: "10px",
                                          width: "100%",
                                          border: `1px solid ${_vm.color.text}`,
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1902693027
                        ),
                        model: {
                          value: _vm.popoverControl.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.popoverControl, "color", $$v)
                          },
                          expression: "popoverControl.color",
                        },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-row",
                              _vm._l(_vm.colorText(), function (item, index) {
                                return _c(
                                  "el-col",
                                  { key: index, attrs: { span: 4 } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "container_item",
                                        class: {
                                          "is-active_color":
                                            _vm.color.text === item,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addColorText(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "option_color",
                                          style: { backgroundColor: item },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Màu nền chữ (Highlight)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "el-popover",
                      {
                        staticClass: "button_control",
                        attrs: { placement: "bottom", width: "160" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "reference",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "button_control style_text",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                            "line-height": "normal",
                                          },
                                        },
                                        [
                                          _c("el-image", {
                                            attrs: { src: _vm.icon.pen_line },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("div", {
                                        style: {
                                          height: "10px",
                                          width: "100%",
                                          border: `1px solid ${_vm.color.background}`,
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          4151779353
                        ),
                        model: {
                          value: _vm.popoverControl.background,
                          callback: function ($$v) {
                            _vm.$set(_vm.popoverControl, "background", $$v)
                          },
                          expression: "popoverControl.background",
                        },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-row",
                              [
                                _vm._l(_vm.colorText(), function (item, index) {
                                  return _c(
                                    "el-col",
                                    { key: index, attrs: { span: 4 } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "container_item",
                                          class: {
                                            "is-active_color":
                                              _vm.color.background === item,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addColorBackground(
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "option_color",
                                            style: { backgroundColor: item },
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                _c("el-col", { attrs: { span: 4 } }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "container_item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.addColorBackground(false)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "option_color",
                                          staticStyle: {
                                            "background-color": "#fff",
                                            display: "flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    x\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Chỉ số dưới (Subscript)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.editor.isActive("subscript"),
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.editor.chain().focus().toggleSubscript().run()
                          },
                        },
                      },
                      [_c("el-image", { attrs: { src: _vm.icon.subscript } })],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Chỉ số trên (Superscript)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.editor.isActive("superscript"),
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.editor.chain().focus().toggleSuperscript().run()
                          },
                        },
                      },
                      [
                        _c("el-image", {
                          attrs: { src: _vm.icon.superscript },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Xuống dòng (Shift + Enter)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.editor.chain().focus().setHardBreak().run()
                          },
                        },
                      },
                      [_c("el-image", { attrs: { src: _vm.icon.break } })],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Đường kẻ ngang phân cách",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.editor.chain().focus().setHorizontalRule().run()
                          },
                        },
                      },
                      [_c("el-image", { attrs: { src: _vm.icon.line } })],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Khối trích dẫn (Blockquote)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.editor.isActive("blockquote"),
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.editor.chain().focus().toggleBlockquote().run()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-chat-square",
                          staticStyle: {
                            "font-size": "16px",
                            color: "#475569",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Khối mã nguồn (Code block)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.editor.isActive("codeBlock"),
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.editor.chain().focus().toggleCodeBlock().run()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-cpu",
                          staticStyle: {
                            "font-size": "16px",
                            color: "#475569",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Chèn biểu tượng cảm xúc (Emoji)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          width: "250",
                          trigger: "click",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "reference",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "button_control",
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        "justify-content": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            width: "16",
                                            height: "16",
                                            fill: "none",
                                            stroke: "#475569",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "12",
                                              cy: "12",
                                              r: "10",
                                            },
                                          }),
                                          _c("path", {
                                            attrs: {
                                              d: "M8 14s1.5 2 4 2 4-2 4-2",
                                            },
                                          }),
                                          _c("line", {
                                            attrs: {
                                              x1: "9",
                                              y1: "9",
                                              x2: "9.01",
                                              y2: "9",
                                            },
                                          }),
                                          _c("line", {
                                            attrs: {
                                              x1: "15",
                                              y1: "9",
                                              x2: "15.01",
                                              y2: "9",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3565852018
                        ),
                        model: {
                          value: _vm.popoverControl.emoji,
                          callback: function ($$v) {
                            _vm.$set(_vm.popoverControl, "emoji", $$v)
                          },
                          expression: "popoverControl.emoji",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "emoji-picker" },
                          _vm._l(_vm.commonEmojis, function (item) {
                            return _c(
                              "span",
                              {
                                key: item,
                                staticClass: "emoji-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.insertEmoji(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Quản lý bảng biểu",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          width: "200",
                          trigger: "click",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "reference",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "button_control",
                                      class: {
                                        "is-active":
                                          _vm.editor.isActive("table"),
                                      },
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        "justify-content": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            width: "16",
                                            height: "16",
                                            fill: "none",
                                            stroke: "#475569",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        },
                                        [
                                          _c("rect", {
                                            attrs: {
                                              x: "3",
                                              y: "3",
                                              width: "18",
                                              height: "18",
                                              rx: "2",
                                            },
                                          }),
                                          _c("line", {
                                            attrs: {
                                              x1: "3",
                                              y1: "9",
                                              x2: "21",
                                              y2: "9",
                                            },
                                          }),
                                          _c("line", {
                                            attrs: {
                                              x1: "3",
                                              y1: "15",
                                              x2: "21",
                                              y2: "15",
                                            },
                                          }),
                                          _c("line", {
                                            attrs: {
                                              x1: "9",
                                              y1: "3",
                                              x2: "9",
                                              y2: "21",
                                            },
                                          }),
                                          _c("line", {
                                            attrs: {
                                              x1: "15",
                                              y1: "3",
                                              x2: "15",
                                              y2: "21",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          4054766914
                        ),
                        model: {
                          value: _vm.popoverControl.table,
                          callback: function ($$v) {
                            _vm.$set(_vm.popoverControl, "table", $$v)
                          },
                          expression: "popoverControl.table",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "table-menu" },
                          [
                            !_vm.editor.isActive("table")
                              ? _c(
                                  "div",
                                  { staticClass: "table-insert-grid" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-weight": "500",
                                          "font-size": "13px",
                                          "margin-bottom": "8px",
                                          color: "#1e293b",
                                          "text-align": "center",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                Chèn bảng: " +
                                            _vm._s(_vm.gridHover.rows || 0) +
                                            " x " +
                                            _vm._s(_vm.gridHover.cols || 0) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "grid-container",
                                        on: { mouseleave: _vm.resetGridHover },
                                      },
                                      _vm._l(8, function (r) {
                                        return _c(
                                          "div",
                                          {
                                            key: "r-" + r,
                                            staticClass: "grid-row",
                                          },
                                          _vm._l(8, function (c) {
                                            return _c("div", {
                                              key: "c-" + c,
                                              staticClass: "grid-cell",
                                              class: {
                                                "is-selected":
                                                  r <= _vm.gridHover.rows &&
                                                  c <= _vm.gridHover.cols,
                                              },
                                              on: {
                                                mouseover: function ($event) {
                                                  return _vm.onGridHover(r, c)
                                                },
                                                click: function ($event) {
                                                  return _vm.createTableFromGrid(
                                                    r,
                                                    c
                                                  )
                                                },
                                              },
                                            })
                                          }),
                                          0
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                )
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-menu-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.execTableCmd(
                                            "addColumnBefore"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-back" }),
                                      _vm._v(" Thêm cột trước\n              "),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-menu-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.execTableCmd(
                                            "addColumnAfter"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-right" }),
                                      _vm._v(" Thêm cột sau\n              "),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-menu-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.execTableCmd(
                                            "deleteColumn"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-close",
                                        staticStyle: { color: "#ef4444" },
                                      }),
                                      _vm._v(" Xóa cột\n              "),
                                    ]
                                  ),
                                  _c("div", {
                                    staticClass: "table-menu-divider",
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-menu-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.execTableCmd(
                                            "addRowBefore"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-top" }),
                                      _vm._v(" Thêm dòng trên\n              "),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-menu-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.execTableCmd("addRowAfter")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-bottom",
                                      }),
                                      _vm._v(" Thêm dòng dưới\n              "),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-menu-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.execTableCmd("deleteRow")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-close",
                                        staticStyle: { color: "#ef4444" },
                                      }),
                                      _vm._v(" Xóa dòng\n              "),
                                    ]
                                  ),
                                  _c("div", {
                                    staticClass: "table-menu-divider",
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-menu-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.execTableCmd(
                                            "mergeOrSplit"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-copy-document",
                                      }),
                                      _vm._v(" Gộp / Tách ô\n              "),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-menu-item",
                                      staticStyle: { color: "#ef4444" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.execTableCmd("deleteTable")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-delete",
                                        staticStyle: { color: "#ef4444" },
                                      }),
                                      _vm._v(" Xóa bảng\n              "),
                                    ]
                                  ),
                                  _c("div", {
                                    staticClass: "table-menu-divider",
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        padding: "6px 8px 4px 8px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "500",
                                            "font-size": "11px",
                                            color: "#64748b",
                                            "margin-bottom": "6px",
                                          },
                                        },
                                        [_vm._v("Màu nền ô")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "grid",
                                            "grid-template-columns":
                                              "repeat(5, 1fr)",
                                            gap: "6px",
                                          },
                                        },
                                        _vm._l(
                                          _vm.tableCellColors,
                                          function (c) {
                                            return _c(
                                              "div",
                                              {
                                                key: c.value,
                                                staticStyle: {
                                                  width: "22px",
                                                  height: "22px",
                                                  "border-radius": "4px",
                                                  border: "1px solid #cbd5e1",
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  "align-items": "center",
                                                  "justify-content": "center",
                                                  "box-sizing": "border-box",
                                                },
                                                style: {
                                                  backgroundColor: c.value,
                                                },
                                                attrs: { title: c.label },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setCellBgColor(
                                                      c.value
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                c.value === "transparent"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-close",
                                                      staticStyle: {
                                                        "font-size": "10px",
                                                        color: "#ef4444",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Danh sách dấu chấm (Bullet list)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.editor.isActive("bulletList"),
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor.chain().focus().toggleBulletList().run()
                          },
                        },
                      },
                      [
                        _c("el-image", {
                          attrs: { src: _vm.icon.list_bulleted },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Danh sách đánh số (Ordered list)",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.editor.isActive("orderedList"),
                          button_control: true,
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor.chain().focus().toggleOrderedList().run()
                          },
                        },
                      },
                      [
                        _c("el-image", {
                          attrs: { src: _vm.icon.list_number },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "button_group-child" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Căn lề trái",
                          placement: "top",
                          "open-delay": 500,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              "is-active": _vm.editor.isActive({
                                textAlign: "left",
                              }),
                              button_control: true,
                            },
                            on: {
                              click: function ($event) {
                                _vm.editor
                                  .chain()
                                  .focus()
                                  .setTextAlign("left")
                                  .run()
                              },
                            },
                          },
                          [
                            _c("el-image", {
                              attrs: { src: _vm.icon.justify_left },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Căn giữa",
                          placement: "top",
                          "open-delay": 500,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              "is-active": _vm.editor.isActive({
                                textAlign: "center",
                              }),
                              button_control: true,
                            },
                            on: {
                              click: function ($event) {
                                _vm.editor
                                  .chain()
                                  .focus()
                                  .setTextAlign("center")
                                  .run()
                              },
                            },
                          },
                          [
                            _c("el-image", {
                              attrs: { src: _vm.icon.justify_center },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Căn lề phải",
                          placement: "top",
                          "open-delay": 500,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              "is-active": _vm.editor.isActive({
                                textAlign: "right",
                              }),
                              button_control: true,
                            },
                            on: {
                              click: function ($event) {
                                _vm.editor
                                  .chain()
                                  .focus()
                                  .setTextAlign("right")
                                  .run()
                              },
                            },
                          },
                          [
                            _c("el-image", {
                              attrs: { src: _vm.icon.justify_right },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Căn đều hai bên",
                          placement: "top",
                          "open-delay": 500,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              "is-active": _vm.editor.isActive({
                                textAlign: "justify",
                              }),
                              button_control: true,
                            },
                            on: {
                              click: function ($event) {
                                _vm.editor
                                  .chain()
                                  .focus()
                                  .setTextAlign("justify")
                                  .run()
                              },
                            },
                          },
                          [
                            _c("el-image", {
                              attrs: { src: _vm.icon.justify },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Chèn liên kết",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active":
                            _vm.editor && _vm.editor.isActive("link"),
                          button_control: true,
                        },
                        on: { click: _vm.openLinkDialog },
                      },
                      [_c("el-image", { attrs: { src: _vm.icon.link } })],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Chèn hình ảnh",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          button_control: true,
                        },
                        on: { click: _vm.openImageDialog },
                      },
                      [_c("el-image", { attrs: { src: _vm.icon.image } })],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Tìm kiếm & Thay thế",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.showSearchReplace,
                          button_control: true,
                        },
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center",
                        },
                        on: { click: _vm.toggleSearchReplace },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-search",
                          staticStyle: {
                            "font-size": "16px",
                            color: "#475569",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button_group" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: _vm.isFullscreen
                        ? "Thu nhỏ cửa sổ"
                        : "Phóng to toàn màn hình",
                      placement: "top",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: {
                          "is-active": _vm.isFullscreen,
                          button_control: true,
                        },
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center",
                        },
                        on: { click: _vm.toggleFullscreen },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 24 24",
                              width: "16",
                              height: "16",
                              fill: "none",
                              stroke: "#475569",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm.showSearchReplace
            ? _c("div", { staticClass: "search-replace-panel" }, [
                _c(
                  "div",
                  { staticClass: "search-replace-row" },
                  [
                    _c("el-input", {
                      staticStyle: { width: "160px" },
                      attrs: {
                        placeholder: "Tìm kiếm từ...",
                        size: "mini",
                        clearable: "",
                      },
                      on: { input: _vm.onSearchInput },
                      model: {
                        value: _vm.searchQuery,
                        callback: function ($$v) {
                          _vm.searchQuery = $$v
                        },
                        expression: "searchQuery",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          color: "#64748b",
                          "min-width": "50px",
                          "text-align": "center",
                          "font-weight": "500",
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.searchStats.current) +
                            " / " +
                            _vm._s(_vm.searchStats.total) +
                            "\n      "
                        ),
                      ]
                    ),
                    _c(
                      "el-button-group",
                      { staticStyle: { "margin-right": "8px" } },
                      [
                        _c("el-button", {
                          staticStyle: { padding: "7px 10px" },
                          attrs: {
                            size: "mini",
                            icon: "el-icon-arrow-left",
                            disabled: _vm.searchStats.total === 0,
                          },
                          on: { click: _vm.handlePrevMatch },
                        }),
                        _c("el-button", {
                          staticStyle: { padding: "7px 10px" },
                          attrs: {
                            size: "mini",
                            icon: "el-icon-arrow-right",
                            disabled: _vm.searchStats.total === 0,
                          },
                          on: { click: _vm.handleNextMatch },
                        }),
                      ],
                      1
                    ),
                    _c("el-input", {
                      staticStyle: { width: "160px", "margin-right": "8px" },
                      attrs: {
                        placeholder: "Thay thế bằng...",
                        size: "mini",
                        clearable: "",
                      },
                      model: {
                        value: _vm.replaceQuery,
                        callback: function ($$v) {
                          _vm.replaceQuery = $$v
                        },
                        expression: "replaceQuery",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          disabled: _vm.searchStats.total === 0,
                        },
                        on: { click: _vm.handleReplace },
                      },
                      [_vm._v("Thay thế")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "success",
                          size: "mini",
                          disabled: _vm.searchStats.total === 0,
                        },
                        on: { click: _vm.handleReplaceAll },
                      },
                      [_vm._v("Thay thế tất cả")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          color: "#64748b",
                          "margin-left": "auto",
                        },
                        attrs: { type: "text", size: "mini" },
                        on: { click: _vm.closeSearchReplace },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-close",
                          staticStyle: { "font-size": "16px" },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c("editor-content", {
            staticClass: "content",
            style: { "--editor-height": _vm.height },
            attrs: { editor: _vm.editor },
          }),
          _c("div", { staticClass: "editor-footer" }, [
            _c("span", { staticClass: "footer-stat" }, [
              _vm._v("Số từ: "),
              _c("strong", [_vm._v(_vm._s(_vm.wordCount))]),
            ]),
            _c("span", { staticClass: "footer-stat-separator" }, [_vm._v("|")]),
            _c("span", { staticClass: "footer-stat" }, [
              _vm._v("Ký tự: "),
              _c("strong", [_vm._v(_vm._s(_vm.charCount))]),
            ]),
          ]),
          _c(
            "DialogBase",
            {
              attrs: {
                visible: _vm.dialogLinkVisible,
                "append-to-body": true,
                title: "Chèn liên kết",
                width: "480px",
                top: "15vh",
                "panel-icon": "el-icon-link",
                "panel-title": "Cấu hình liên kết",
                "panel-subtitle":
                  "Nhập đường dẫn trang web và văn bản hiển thị",
                "show-confirm": !_vm.linkForm.isEditing,
                "confirm-text": "Chèn liên kết",
                "confirm-icon": "el-icon-circle-check",
                "confirm-type": "primary",
                "cancel-text": "Hủy",
              },
              on: {
                confirm: _vm.handleConfirmLink,
                cancel: function ($event) {
                  _vm.dialogLinkVisible = false
                },
                "update:visible": function ($event) {
                  _vm.dialogLinkVisible = $event
                },
              },
              scopedSlots: _vm._u(
                [
                  _vm.linkForm.isEditing
                    ? {
                        key: "footer",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "dialog-footer-custom" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "danger",
                                      plain: "",
                                      icon: "el-icon-delete",
                                    },
                                    on: { click: _vm.handleRemoveLink },
                                  },
                                  [_vm._v("Xóa liên kết")]
                                ),
                                _c("div", { staticStyle: { flex: "1" } }),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        _vm.dialogLinkVisible = false
                                      },
                                    },
                                  },
                                  [_vm._v("Hủy")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "success",
                                      icon: "el-icon-circle-check",
                                    },
                                    on: { click: _vm.handleConfirmLink },
                                  },
                                  [_vm._v("Lưu liên kết")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      }
                    : null,
                ],
                null,
                true
              ),
            },
            [
              _c(
                "div",
                { staticClass: "dialog-link-wrapper" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { "label-position": "top", size: "small" },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.handleConfirmLink.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Đường dẫn (URL)" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "https://example.com",
                              "prefix-icon": "el-icon-link",
                              clearable: "",
                            },
                            model: {
                              value: _vm.linkForm.url,
                              callback: function ($$v) {
                                _vm.$set(_vm.linkForm, "url", $$v)
                              },
                              expression: "linkForm.url",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Văn bản hiển thị" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "Nhập chữ hiển thị (để trống nếu dùng chữ đã bôi đen)",
                              "prefix-icon": "el-icon-edit-outline",
                              clearable: "",
                            },
                            model: {
                              value: _vm.linkForm.text,
                              callback: function ($$v) {
                                _vm.$set(_vm.linkForm, "text", $$v)
                              },
                              expression: "linkForm.text",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "link-option-row" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.linkForm.openInNewTab,
                                callback: function ($$v) {
                                  _vm.$set(_vm.linkForm, "openInNewTab", $$v)
                                },
                                expression: "linkForm.openInNewTab",
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-open" }),
                              _vm._v(" Mở trong thẻ mới\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "DialogBase",
            {
              attrs: {
                visible: _vm.dialogImageVisible,
                "append-to-body": true,
                title: "Chèn hình ảnh",
                width: "540px",
                top: "12vh",
                "panel-icon": "el-icon-picture-outline",
                "panel-title": "Chèn hình ảnh vào nội dung",
                "panel-subtitle":
                  "Tải ảnh từ máy tính hoặc chèn trực tiếp từ đường dẫn URL",
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.dialogImageVisible = false
                },
                "update:visible": function ($event) {
                  _vm.dialogImageVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialog-image-wrapper" },
                [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "image-dialog-tabs",
                      attrs: { type: "card" },
                      model: {
                        value: _vm.imageTabActive,
                        callback: function ($$v) {
                          _vm.imageTabActive = $$v
                        },
                        expression: "imageTabActive",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: "Tải ảnh từ máy tính",
                            name: "upload",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "upload-tab-content" },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "image-drag-uploader",
                                  attrs: {
                                    drag: "",
                                    action: "",
                                    "auto-upload": false,
                                    accept: "image/*",
                                    "on-change": _vm.handleImageFileSelect,
                                    "show-file-list": false,
                                  },
                                },
                                [
                                  !_vm.imageForm.previewUrl
                                    ? _c(
                                        "div",
                                        { staticClass: "upload-drag-inner" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-upload",
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "el-upload__text" },
                                            [
                                              _vm._v(
                                                "Kéo thả hình ảnh vào đây hoặc "
                                              ),
                                              _c("em", [
                                                _vm._v("nhấp để chọn tệp"),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "el-upload__tip" },
                                            [
                                              _vm._v(
                                                "Hỗ trợ định dạng JPG, PNG, GIF, WEBP (Tối đa 5MB)"
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "upload-preview-inner" },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "preview-img-thumbnail",
                                            attrs: {
                                              src: _vm.imageForm.previewUrl,
                                              alt: "Xem trước ảnh",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "preview-img-info" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "img-filename" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.imageForm.file
                                                        ? _vm.imageForm.file
                                                            .name
                                                        : "Hình ảnh đã chọn"
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    icon: "el-icon-refresh",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      _vm.imageForm.previewUrl =
                                                        ""
                                                      _vm.imageForm.file = null
                                                    },
                                                  },
                                                },
                                                [_vm._v("Chọn ảnh khác")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "dialog-action-row" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          _vm.dialogImageVisible = false
                                        },
                                      },
                                    },
                                    [_vm._v("Hủy")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "small",
                                        type: "success",
                                        icon: "el-icon-circle-check",
                                        loading: _vm.loadingButton.addImage,
                                        disabled: !_vm.imageForm.file,
                                      },
                                      on: {
                                        click: _vm.handleConfirmImageUpload,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Tải lên & Chèn ảnh\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: { label: "Chèn từ URL hình ảnh", name: "url" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "url-tab-content" },
                            [
                              _c(
                                "el-form",
                                {
                                  attrs: {
                                    "label-position": "top",
                                    size: "small",
                                  },
                                  nativeOn: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.handleConfirmImageUrl.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Đường dẫn ảnh (URL)" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder:
                                            "https://example.com/hinh-anh.jpg",
                                          "prefix-icon": "el-icon-link",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.imageForm.url,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.imageForm, "url", $$v)
                                          },
                                          expression: "imageForm.url",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.imageForm.url
                                    ? _c(
                                        "div",
                                        { staticClass: "url-img-preview-box" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "preview-label" },
                                            [_vm._v("Xem trước hình ảnh:")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "preview-img-card" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.imageForm.url,
                                                  alt: "Preview",
                                                },
                                                on: {
                                                  error:
                                                    _vm.handleImagePreviewError,
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "dialog-action-row",
                                  staticStyle: { "margin-top": "20px" },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          _vm.dialogImageVisible = false
                                        },
                                      },
                                    },
                                    [_vm._v("Hủy")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "small",
                                        type: "success",
                                        icon: "el-icon-circle-check",
                                        disabled: !_vm.imageForm.url,
                                      },
                                      on: { click: _vm.handleConfirmImageUrl },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Chèn hình ảnh\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }